





import DEmpty from '../../index';
import Vue from 'vue';
import Component from 'vue-class-component';

Vue.use(DEmpty);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  // TODO
}
